import Mobile from '@/pages/mobile/view'
import EnterPhone from '@/pages/mobile/enterPhone'
import BranchEnterPhone from '@/pages/mobile/branch/enterPhone'
import EnterCar from '@/pages/mobile/enterCar'
import BranchEnterCar from '@/pages/mobile/branch/enterCar'
import ConfirmMsg from '@/pages/mobile/confirmMsg'
import ConfirmPay from '@/pages/mobile/confirmPay'
import QueryFail from '@/pages/mobile/queryFail'
import ResultPay from '@/pages/mobile/resultPay'
import Recharge from '@/pages/mobile/recharge'
import Ticket from '@/pages/mobile/ticket'
import OpenRenew_Card from '@/pages/mobile/openRenew_Card.vue'
import OpenCardDetails from '@/pages/mobile/openCardDetails.vue'
import RenewalDetails from '@/pages/mobile/renewalDetails.vue'
import RenewalHistory from '@/pages/mobile/renewalHistory.vue'



const mobile=[
    {
        path: '/mobile',
        name: 'mobile',
        component: Mobile,
        children: [
            {
                path: 'enterPhone/:parkNo/:passid',
                name: 'enterPhone',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'无人值守停车系统'
                },
                component: EnterPhone
            },
            {
                path: 'branch/enterPhone/:parkNo/:passid',
                name: 'branchEnterPhone',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'无人值守停车系统'
                },
                component: BranchEnterPhone
            },
            {
                path: 'enterCar/:parkNo/:passid',
                name: 'enterCar',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'无人值守停车系统'
                },
                component: EnterCar
            },
            {
                path: 'branch/enterCar/:parkNo/:passid',
                name: 'branchEnterCar',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'无人值守停车系统'
                },
                component: BranchEnterCar
            },
            {
                path: 'confirmMsg/:carNo',
                name: 'confirmMsg',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'信息确认'
                },
                component: ConfirmMsg
            },
            {
                path: 'confirmPay/:carNo',
                name: 'confirmPay',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'确认支付'
                },
                component: ConfirmPay
            },
            {
                path: 'queryFail/:carNo',
                name: 'queryFail',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'查询失败'
                },
                component: QueryFail
            },
            {
                path: 'resultPay',
                name: 'resultPay',
                meta: {
                    title:'无人值守停车系统',
                    subTitle:'结果'
                },
                component: ResultPay
            },
            {
                path: 'recharge/:token/:userTel',
                name: 'recharge',
                meta: {
                    title: '道闸商户平台',
                    subTitle: '商户充值'
                },
                component: Recharge
            },
            {
                path: 'ticket/:busNo/:parkNo/:freeDuration/:timestanp',
                name: 'Ticket',
                meta: {
                    title: '道闸商户平台',
                    subTitle: '道闸商户平台'
                },
                component: Ticket
            },
            {
             path:'openRenew_Card/:parkNum/:isCard/:parkType/:rulesNum',
             name:'OpenRenew_Card',
             meta: {
                  title: '无人值守停车系统',
                  subTitle: '请输入车牌'
              },
              component: OpenRenew_Card
            },
            {
             path:'openCardDetails',
             name:'OpenCardDetails',
             meta: {
                  title: '无人值守停车系统',
                  subTitle: '开卡'
              },
              component: OpenCardDetails
            },
            {
             path:'renewalDetails',
             name:'RenewalDetails',
             meta: {
                  title: '无人值守停车系统',
                  subTitle: '续费'
              },
              component: RenewalDetails
            },
            {
              path:'renewalHistory/:parkNo/:carNo',
              name:'RenewalHistory',
              meta: {
                   title: '无人值守停车系统',
                   subTitle: '缴费历史记录'
               },
               component: RenewalHistory
            },
            {
                path:'Monitorrenewal',
                name:'MonitorRenewal',
                meta:{
                    title:'无人值守停车系统',
                    subTitle:'通道监控续费'
                },
                component: ()=> import("@/pages/mobile/MonitorRenewal")
            }

        ]
    }
]

export default mobile



// WEBPACK FOOTER //
// ./src/router/mobile.js